import gql from 'graphql-tag';

import client from '../graphqlAPI';

// The editable cells of ONE plate, and how much of its copy they account for.
//
// Deliberately a separate query from getEmailTemplatesList rather than two more
// fields on it. `editableCells` and `cellCoverage` are field resolvers that
// re-scan htmlContent on every request (ps-back/graphql/resolvers/EmailTemplate.js);
// GraphQL runs them only when they are asked for, and the campaign list asks
// getEmailTemplates for up to 88 documents at a time. Adding the fields to the
// shared query would make every list render scan 88 emails for cells that only
// the press check ever reads.
//
// There is no single-template query in the schema, so this filters
// getEmailTemplates by scope+language the way the editor's own load does. It
// asks for templateId as well: a plate whose templateId does not match the one
// on screen is a stale response, and the caller drops it.
const GET_EMAIL_TEMPLATE_CELLS = gql`
query getEmailTemplateCells($scope: String, $language: String) {
  getEmailTemplates(scope: $scope, language: $language) {
    isAuth
    error
    templates {
      templateId
      cellCoverage
      editableCells {
        id
        text
        innerHtml
        chars
      }
    }
  }
}
`;

const getEmailTemplateCells = async (variables) => {
  try {
    const result = await client.query({
      query: GET_EMAIL_TEMPLATE_CELLS,
      variables,
      errorPolicy: 'all',
      fetchResults: true,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { getEmailTemplates: templatesData } } = result;

    if (templatesData) {
      return templatesData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getEmailTemplateCells = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getEmailTemplateCells Error: ${error}`);
    return null;
  }
};

export default getEmailTemplateCells;
